import { Injectable } from '@angular/core'

import { Observable, map } from 'rxjs'

import { MediaAppInfo } from '@flowx/designer/modules/core/dictionary/media-library.dictionary'
import { ApiHttpProxyService } from '@flowx/designer/shared/api/api-http-proxy.service'

import { MediaLibraryManager } from './media-library.api'

@Injectable({ providedIn: 'root' })
export class MediaLibraryNominalApi extends ApiHttpProxyService implements MediaLibraryManager {
  cmsUrl = 'cms/api/media-library/files'
  globalAssetsUrl = 'include-dep-res/cms/api/media-library/files/app-and-global'

  getMediaLibraryResources<MediaLibraryResource>(
    params: any,
    allImages = false
  ): Observable<{
    resourceContent: MediaLibraryResource[]
    appsInfo?: MediaAppInfo
  }> {
    return this.httpClient.get<{
      resourceContent: MediaLibraryResource[]
      appsInfo?: MediaAppInfo
    }>(`${this.#getMediaLibraryBaseUrl()}/${allImages ? this.globalAssetsUrl : this.cmsUrl}`, {
      params: allImages
        ? this.addParams({
            ...params,
            includeAppsInfo: true,
            depTypes: ['LIB', 'API'],
          })
        : this.addParams(params),
    })
  }

  addFile(newFile: FormData): Observable<any> {
    return this.httpClient
      .post(`${this.#getMediaLibraryBaseUrl()}/with-file/${this.cmsUrl}`, newFile)
      .pipe(map((response: any) => response.resourceContent))
  }

  checkImageVersion(imageId: string): Observable<any> {
    return this.httpClient.get(`${this.#getMediaLibraryBaseUrl()}/ri/${imageId}/${this.cmsUrl}`)
  }

  updateImage(imageId: string, newImage: FormData): Observable<any> {
    return this.httpClient
      .put(`${this.#getMediaLibraryBaseUrl()}/ri/${imageId}/with-file/${this.cmsUrl}`, newImage)
      .pipe(map((response: any) => response.resourceContent))
  }

  deleteImage(id: string): Observable<any> {
    return this.httpClient.delete(`${this.#getMediaLibraryBaseUrl()}/ri/${id}/${this.cmsUrl}`, {
      params: { force: true },
    })
  }

  exportMediaLibraryResources(resourcesIds: string[]): Observable<any> {
    return this.httpClient.post(
      `${this.#getMediaLibraryBaseUrl('export')}/cms/api/rt/mediafile/export`,
      { resourcesIds },
      { responseType: 'blob' }
    )
  }

  exportMediaLibraryResourcesWithBinaries(resourcesIds: string[]): Observable<any> {
    return this.httpClient.post(
      `${this.#getMediaLibraryBaseUrl('export-with-binaries')}/cms/api/rt/mediafile/export`,
      { resourcesIds },
      { responseType: 'blob' }
    )
  }

  importImages<T>(payload: T): Observable<any> {
    return this.httpClient.post(`${this.#getMediaLibraryBaseUrl('import')}`, payload)
  }

  #getMediaLibraryBaseUrl = (suffix?: string): string => {
    const { appId, appVersionId } = this.urlParametersStoreService.urlParameters
    let proxyBaseUrl = `${this.getProxyBaseUrl(appId, appVersionId)}`

    if (suffix) {
      proxyBaseUrl += `/${suffix}`
    }

    return `${proxyBaseUrl}/rt/mediafile`
  }
}
